import './Calendar.css';
import React from 'react'
import Calendar from 'react-calendar'
import { useState } from 'react';

const Component = ({selectedDate,setDate}) => {  
const dateToday = new Date();
const endOfMonth = new Date(dateToday.getFullYear(), dateToday.getMonth() + 1, 0);
   return (
    <div>
      <div className="calendar-container">
        <Calendar onChange={setDate} value={selectedDate} maxDate={endOfMonth}
                  
                  minDetail="month"
        />
      </div>
    </div>
    
  )
};

export default Component;